import { ModelBase } from '../../core/model/model-base';
import { CreditorResponsibility } from './const/enums';

export class ContractSecurity extends ModelBase {
  constructor(dataContext?: any) {
    super();
    if (dataContext) {
      this.id = dataContext.Id;
      this.leaseAgreementId = dataContext.leaseAgreementId;
      this.contactId = dataContext.ContactId;
      this.comment = dataContext.comment;
      this.responsibility = dataContext.responsibility;
    }
  }
  id: string;
  leaseAgreementId: string;
  contactId: string;
  comment: string;
  responsibility: CreditorResponsibility;
}
